import * as React from 'react';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

import {CreatePageButton} from './create-page/create-page-button';

export function EmptyState() {
    return (
        <EmptyStateLarge
            title='Begin creating engaging pages'
            subtitle='Explore our comprehensive features for designing landing pages that deliver results.'
            detailTextBullets={[
                'Personalize a template or start from scratch using our intuitive drag-and-drop editor',
                'Ensure your pages are responsive and display perfectly on all screens, from desktop to mobile',
                'Track page performance and optimize for success using integrated analytics',
            ]}
            cta={<CreatePageButton isLarge={true} />}
            icon={<Illustration src='pushing-website' width={320} />}
        />
    );
}
